document.addEventListener("DOMContentLoaded", function () {
  const popupTrigger = document.getElementById("popupTrigger");
  const popupWindow = document.getElementById("popupWindow");
  const closePopup = document.getElementById("closePopup");
  
  if (popupTrigger && popupWindow) {
    popupTrigger.addEventListener("click", function () {
      popupWindow.classList.remove("hidden");
    });
    
    if (closePopup) {
      closePopup.addEventListener("click", function () {
        popupWindow.classList.add("hidden");
      });
    }
    
    popupWindow.addEventListener("click", function (e) {
      if (e.target === popupWindow) {
        popupWindow.classList.add("hidden");
      }
    });
  }
  const searchPopup = document.querySelector(".mobile-search-popup");
  const searchContainer = document.querySelector(".mobile-search-container");
  const toggleButton = document.querySelector(".mobile-search-btn");
  if (toggleButton && searchPopup && searchContainer) {
    toggleButton.addEventListener("click", (event) => {
      event.preventDefault();
      searchPopup.classList.toggle("active");
      document.documentElement.classList.toggle("prevent-scroll"); // Toggles on <html>
    });
    // Click outside the search container to close
    searchPopup.addEventListener("click", (event) => {
      if (!searchContainer.contains(event.target)) {
        searchPopup.classList.remove("active");
        document.documentElement.classList.remove("prevent-scroll");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  document.body.addEventListener('change', function(event) {
    if (event.target && event.target.matches('.activation-date')) {
      const input = event.target;
      const container = input.closest('.activation-date-container');
      if (!container) return;  // PDP input has no container — cart-side handler only
      const lineId = container.getAttribute('data-line');
      const lineKey = container.getAttribute('data-item-key');
      const itemID = container.getAttribute('data-item-id');
      const cartChangeUrl = container.getAttribute('data-cart-change-url');
      const lineQty = container.getAttribute('data-qty');  // Get the quantity directly
      // Log lineId, lineKey, and lineQty for debugging
      console.log("Line ID: ", lineId);
      console.log("Line Key: ", lineKey);
      console.log("Item ID: ", itemID);
      console.log("Line Quantity: ", lineQty);
      // Fetch the current cart using Shopify's /cart.js API
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Log the cart object to check its contents
          console.log("Cart Items:", cart.items);
          // Build the updated properties string (comma-separated dates for all SIMs in this line)
          let updatedProperties = "";
          // Gather all SIM dates into the updatedProperties string for the same line
          input.closest('.activation-date-container').querySelectorAll('.activation-date').forEach(function(input, index) {
            const simIndex = index + 1;
            const simDate = input.value;
            // Format the date as DD/MM/YYYY
            const formattedDate = formatDate(simDate);
            if (formattedDate) {
              updatedProperties += "SIM " + simIndex + ": " + formattedDate;
              if (index < input.closest('.activation-date-container').querySelectorAll('.activation-date').length - 1) {
                updatedProperties += ", ";
              }
            }
          });
          // Log the updated properties string
          console.log("Updated Properties: ", updatedProperties);
          // Prepare the request body with the updated properties for this specific item using the itemID
          const requestBody = {
            id: itemID,  // Use itemID to target the item in the cart
            properties: {
              'arrival_date': updatedProperties
            },
            quantity: lineQty  // Include the quantity, as it's part of the cart update
          };
          // Log the request body before sending the fetch request
          console.log("Request Body: ", requestBody);
          // Send the updated request to Shopify's cart change URL
          fetch(cartChangeUrl + '.js', {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
          .then(response => response.json())  // Parse the JSON response
          .then(cart => {
            // Log the entire cart response to inspect the quantity and other data
            console.log('Cart updated:', cart);
          })
          .catch(error => {
            // Handle any errors that occurred during the fetch
            console.error('Error updating cart:', error);
          });
        })
        .catch(error => {
          // Handle any errors with fetching the cart
          console.error('Error fetching cart:', error);
        });
    }
  });
  // Function to format date in DD/MM/YYYY
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    if (isNaN(date)) return null;  // Invalid date check
    const day = String(date.getDate()).padStart(2, '0');  // Ensure two-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Ensure two-digit month
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;  // Return formatted date
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Check if the popup container exists
  const popupContainer = document.querySelector(".arrival-popup-container");
  if (popupContainer) {
    // Delegate event listener to the document for dynamically added triggers
    document.addEventListener("click", function (e) {
      const trigger = e.target.closest(".arrival-popup"); // Check if the clicked element or its ancestor is a trigger
      if (trigger) {
        e.preventDefault();
        popupContainer.style.display = "flex"; // Show the popup
      }
    });
    // Close popup when close button is clicked
    const closeButton = document.querySelector(".arrival-popup-close");
    if (closeButton) {
      closeButton.addEventListener("click", function () {
        popupContainer.style.display = "none"; // Hide popup
      });
    }
    // Close popup when clicking outside the inner content
    popupContainer.addEventListener("click", function (e) {
      if (e.target === popupContainer) {
        popupContainer.style.display = "none"; // Hide popup
      }
    });
  }
});

// 移除了未定义的 attachDateValidation 函数调用
// 直接初始化动态条款复选框功能
function initDynamicTermsCheckbox() {
  // Define the containers to target
  const containers = ['#cart-drawer-container', '.checkout-form'];
  containers.forEach((selector) => {
    const parentContainer = document.querySelector(selector);
    // Skip if the container does not exist
    if (!parentContainer) return;
    // Event delegation for the agree-terms checkbox
    parentContainer.addEventListener('change', (e) => {
      if (e.target.matches('.agree-terms [name="agree_terms"]')) {
        const checkbox = e.target;
        const button = checkbox.closest('.agree-terms').nextElementSibling;
        if (button && button.hasAttribute('data-terms-action')) {
          const allDatePickers = parentContainer.querySelectorAll('.activation-date');
          let allDatesFilled = true;
          // Check if all dynamic date pickers have a value
          allDatePickers.forEach((datePicker) => {
            if (!datePicker.value) {
              allDatesFilled = false;
            }
          });
          if (checkbox.checked) {
            if (allDatesFilled) {
              button.removeAttribute('disabled'); // Enable the button
            } else {
              alert('Please select all arrival dates before proceeding.');
              checkbox.checked = false; // Uncheck the checkbox
            }
          } else {
            button.setAttribute('disabled', true); // Disable the button
          }
        }
      }
    });
    // Event delegation for the dynamic date pickers
    parentContainer.addEventListener('change', (e) => {
      if (e.target.matches('.activation-date')) {
        const agreeTermsCheckbox = parentContainer.querySelector('.agree-terms [name="agree_terms"]');
        const button = parentContainer.querySelector('.agree-terms').nextElementSibling;
        if (agreeTermsCheckbox && agreeTermsCheckbox.checked) {
          const allDatePickers = parentContainer.querySelectorAll('.activation-date');
          let allDatesFilled = true;
          // Check if all date pickers have a value
          allDatePickers.forEach((datePicker) => {
            if (!datePicker.value) {
              allDatesFilled = false;
            }
          });
          if (allDatesFilled) {
            button.removeAttribute('disabled'); // Enable the button
          } else {
            button.setAttribute('disabled', true); // Disable the button
          }
        }
      }
    });
  });
}

// Initialize the dynamic terms and date picker validation for multiple containers
initDynamicTermsCheckbox();